import { type AppRole, rolesOfUser } from '@/utils/auth';
import { useMemo } from 'react';
import { useAuth } from 'react-oidc-context';

export interface RolesState {
  roles: AppRole[];
  /** May configure the detection (`app-admin`; superadmins carry it too). Admins are users too. */
  isAdmin: boolean;
  /** May edit every item, rename system categories and edit the system prompt (`app-superadmin`). */
  isSuperadmin: boolean;
  /** May run the document workflow (`app-user` or `app-admin`). */
  isUser: boolean;
}

/** The signed-in user's application roles, read from the OIDC user. */
export const useRoles = (): RolesState => {
  const { user } = useAuth();
  return useMemo(() => {
    const roles = rolesOfUser(user);
    const isSuperadmin = roles.includes('app-superadmin');
    const isAdmin = isSuperadmin || roles.includes('app-admin');
    return { roles, isAdmin, isSuperadmin, isUser: isAdmin || roles.includes('app-user') };
  }, [user]);
};
